module.exports = __webpack_public_path__ + "officialStatic/img/case-rb.92843af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case-rb.jpg
// module id = 28Uq
// module chunks = 0